/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfilePreviewAddress
 */
export interface StoreProfilePreviewAddress {
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    geoLat?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    geoLon?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    placeId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewAddress
     */
    additional: string;
}

/**
 * Check if a given object implements the StoreProfilePreviewAddress interface.
 */
export function instanceOfStoreProfilePreviewAddress(value: object): value is StoreProfilePreviewAddress {
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('additional' in value) || value['additional'] === undefined) return false;
    return true;
}

export function StoreProfilePreviewAddressFromJSON(json: any): StoreProfilePreviewAddress {
    return StoreProfilePreviewAddressFromJSONTyped(json, false);
}

export function StoreProfilePreviewAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfilePreviewAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'houseNumber': json['houseNumber'],
        'street': json['street'],
        'zip': json['zip'],
        'city': json['city'],
        'country': json['country'],
        'countryCode': json['countryCode'],
        'geoLat': json['geoLat'] == null ? undefined : json['geoLat'],
        'geoLon': json['geoLon'] == null ? undefined : json['geoLon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'additional': json['additional'],
    };
}

export function StoreProfilePreviewAddressToJSON(json: any): StoreProfilePreviewAddress {
    return StoreProfilePreviewAddressToJSONTyped(json, false);
}

export function StoreProfilePreviewAddressToJSONTyped(value?: StoreProfilePreviewAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'houseNumber': value['houseNumber'],
        'street': value['street'],
        'zip': value['zip'],
        'city': value['city'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'geoLat': value['geoLat'],
        'geoLon': value['geoLon'],
        'placeId': value['placeId'],
        'additional': value['additional'],
    };
}

